export const environment = {
  version: '1.40',
  production: true,
  apiUrl: '/api/',
  modeDebug: true,
  domain: 'localhost'
};
